// extracted by mini-css-extract-plugin
export var aboveText = "InfoBanner-module--aboveText--0c41f";
export var buttonsWrapp = "InfoBanner-module--buttonsWrapp--4527e";
export var content = "InfoBanner-module--content--4d383";
export var intro = "InfoBanner-module--intro--e4996";
export var mobileLeft = "InfoBanner-module--mobileLeft--6893b";
export var section = "InfoBanner-module--section--6973f";
export var subHeading = "InfoBanner-module--subHeading--1dbf9";
export var textLogo = "InfoBanner-module--textLogo--6a7d4";
export var title = "InfoBanner-module--title--750c8";
export var top = "InfoBanner-module--top--bea34";